'use strict';

module.exports = require('./matrix');
module.exports.Decompositions = module.exports.DC = require('./decompositions');



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-pls/~/ml-matrix/src/index.js
 ** module id = 117
 ** module chunks = 0
 **/